import { styled } from '@mui/material/styles';

const ColorDot = styled('div')(() => ({
  width: '14px',
  height: '14px',
  borderRadius: '50%',
}));

export default ColorDot
